import Vue from 'vue';
import { USER_PRIVILEGE } from '@/utilsAuth';

const env = process.env;

export const hasFeature = (key) => env[`VUE_APP_FEATURE_${key.toUpperCase()}`] === 'true';

export const isHaveRole = (role) => {
  const userPermission = Vue.$cookies.get(USER_PRIVILEGE);

  if(userPermission == "admin"){
    return true;
  }
  return userPermission?.includes(role);
};